import AnimationController from '../../../assets/js/controllers/animation';
import ResizeController from '../../../assets/js/controllers/resize';

import Platform from '../../../assets/js/constants/platform';

import { multiAddEventListener, multiClassList, multiRemoveEventListener, validateParamBoolean, validateParamNumber } from '../../../assets/js/helpers';

export default class SplitOverlayProduct3Up {

	static selector = 'split-overlay-product-3-up';

	// class variables

	el = {};

	controllers = {
		resize: null
	};

	coords = {
		hero: null,
		footer: null,
		overlay: {
			totalHeight: 0
		}
	};

	flags = {
		isMobile: false
	};

	// constructor

	constructor(container) {
		this.el = {
			container,
			productsWrapper: container.querySelector(`.${this.constructor.selector}__content-wrapper`),
			products: container.querySelectorAll(`.${this.constructor.selector}__product`),
			productImages: container.querySelectorAll(`.${this.constructor.selector}__product-image`),
			overlays: container.querySelectorAll(`.${this.constructor.selector}__overlay`),
			expandCtas: container.querySelectorAll('[data-expand-cta]'),
			closeCtas: container.querySelectorAll('[data-close-cta]'),
		};

		this.initialize();
	}

	// init

	initialize() {
		this.#addEventListeners();
		if (document.body.querySelector('.navigation-anchor')) {
			const stickiesOffset = this.el.container.querySelectorAll('[data-sticky-offset]');
			for (let i = 0; i < stickiesOffset.length; i++) {
				const $sticky = stickiesOffset[i];
				$sticky.dataset.stickyOffset = validateParamNumber($sticky, 'data-sticky-offset') + 65;
			}
		}
	}

	// event listeners

	#addEventListeners = () => {
		multiAddEventListener(this.el.expandCtas, 'click', this.#onProductCtaExpandClick);
		multiAddEventListener(this.el.closeCtas, 'click', this.#onProductCtaCloseClick);

		this.controllers.resize = ResizeController.set({
			update: this.#onResizeUpdate,
			render: this.#onResizeRender
		});
	}

	#removeEventListeners = () => {
		multiRemoveEventListener(this.el.expandCtas, 'click', this.#onProductCtaExpandClick);
		multiRemoveEventListener(this.el.closeCtas, 'click', this.#onProductCtaCloseClick);

		ResizeController.clear(this.controllers.resize);
	}

	// listener methods

	#onProductCtaExpandClick = (e) => {
		e.preventDefault();

		const $product = e.target.closest(`.${this.constructor.selector}__product`);
		if (validateParamBoolean($product, 'data-has-overlay')) {
			if ($product.classList.contains('is-active')) {
				this.collapse();
			} else {
				this.expand($product);
			}
		}
	}

	#onProductCtaCloseClick = (e) => {
		e.preventDefault();
		this.collapse();
	}

	#onResizeUpdate = () => {
		let isChanged = ResizeController.isPlatformChange;

		const lastOverlayHeight = this.coords.overlay.totalHeight;
		this.coords.overlay.totalHeight = this.#measureOverlayHeight();

		if (lastOverlayHeight !== this.coords.overlay.totalHeight) {
			isChanged = true;
		}

		return isChanged;
	}

	#onResizeRender = () => {
		if (ResizeController.platform !== Platform.MOBILE && ResizeController.isPlatformChange) {
			this.collapse();
		}

		this.#resizeActiveProduct();
	}

	//

	#measureOverlayHeight = () => {
		const $activeProduct = multiClassList(this.el.products, 'contains', 'is-active')[0];
		if ($activeProduct) {
			const $overlay = $activeProduct.querySelector(`.${this.constructor.selector}__overlay`);
			const $overlayInnerWrapper = $activeProduct.querySelector(`.${this.constructor.selector}__overlay-inner-wrapper`);
			const overlayStyles = getComputedStyle($overlay);
			const totalHeight = `${parseInt($overlayInnerWrapper.offsetHeight) + parseInt(overlayStyles.top)}px`;
			return totalHeight;
		}
		return -1;
	}

	#resizeActiveProduct = () => {
		const $activeProduct = multiClassList(this.el.products, 'contains', 'is-active')[0];
		if ($activeProduct) {
			// $activeProduct.style.minHeight = this.coords.overlay.totalHeight;
		}
	}

	// expand / collapse

	expand($product) {
		const $activeProduct = multiClassList(this.el.products, 'contains', 'is-active')[0];

		if ($product !== $activeProduct) {
			// let product wrapper know it is expanded
			this.el.productsWrapper.classList.add('is-active');

			// make other products inactive
			for (let i = 0; i < this.el.products.length; i++) {
				const $curProduct = this.el.products[i];
				if ($curProduct !== $product) {
					$curProduct.style.minHeight = '';
					$curProduct.classList.add('is-inactive');
					$curProduct.classList.remove('is-active', 'is-in');

					this.el.overlays[i].classList.add('is-inactive');
					this.el.overlays[i].classList.remove('is-active', 'is-in');
				}
			}

			multiClassList(this.el.closeCtas, 'remove', ['is-active', 'is-in']);
			multiClassList(this.el.expandCtas, 'remove', ['is-active', 'is-in']);
			multiClassList(this.el.products, 'remove', ['is-idle']);

			// make current product active
			const $overlay = $product.querySelector(`.${this.constructor.selector}__overlay`);

			$overlay.classList.add('is-active');
			$product.classList.add('is-active');

			$overlay.classList.remove('is-inactive');
			$product.classList.remove('is-inactive');

			$product.querySelector(`.${this.constructor.selector}__product-expand-cta`).classList.add('is-active');

			setTimeout(() => {
				this.coords.overlay.totalHeight = this.#measureOverlayHeight();
				this.#resizeActiveProduct();
			}, 600);

			// delayed animation frame to animate overlay elements in
			AnimationController.one({
				update: () => true,
				render: () => {
					$overlay.classList.add('is-in');
					$product.classList.add('is-in');
				}
			});
		}
	}

	collapse() {
		this.el.productsWrapper.classList.remove('is-active');

		for (let i = 0; i < this.el.products.length; i++) {
			const $curProduct = this.el.products[i];
			$curProduct.style.minHeight = '';
		}

		multiClassList(this.el.closeCtas, 'remove', ['is-active', 'is-in']);
		multiClassList(this.el.expandCtas, 'remove', ['is-active', 'is-in']);

		multiClassList(this.el.overlays, 'remove', ['is-active', 'is-inactive', 'is-in']);
		multiClassList(this.el.products, 'remove', ['is-active', 'is-inactive', 'is-in']);

		multiClassList(this.el.products, 'add', ['is-idle']);
	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
